const titles = ['software engineer', 'musician', 'gamer', 'dad']

export default titles
